// extracted by mini-css-extract-plugin
module.exports = {"root":"v0RQQz","buyer-note-divider":"iJoCCT","buyerNoteDivider":"iJoCCT","divider":"Dl1ucB","section":"adDAwa","totals":"aNdpCM"};